
import { useContext } from 'react';
import { AuthContext, AuthContextType } from './AuthContext';

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    console.error("useAuth was called outside of AuthProvider! This will cause undefined behavior.");
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default useAuth;
